import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import clinicService from "../../services/clinic.service";
import "../reputation/reputation.css";
import "./unsubscribe.css";

const UnsubscribePage = () => {
  const { clinicId, patientId } = useParams();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | success | error

  useEffect(() => {
    if (!clinicId || !patientId) {
      setStatus("error");
      return;
    }

    const type = searchParams.get("type");
    const data = searchParams.get("data");

    let cancelled = false;

    clinicService
      .unsubscribe(clinicId, patientId, type, data)
      .then(() => {
        if (!cancelled) setStatus("success");
      })
      .catch(() => {
        if (!cancelled) setStatus("error");
      });

    return () => {
      cancelled = true;
    };
  }, [clinicId, patientId, searchParams]);

  if (status === "loading") {
    return (
      <div className="unsubscribe-state" aria-busy="true">
        <div className="rep-spinner" role="status" aria-label="Unsubscribing" />
        <p className="unsubscribe-hint">Processing your request…</p>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="rep-shell unsubscribe-shell">
        <section className="rep-panel unsubscribe-panel">
          <div className="unsubscribe-icon unsubscribe-icon--error" aria-hidden="true">
            <i className="bi bi-exclamation-circle" />
          </div>
          <p className="rep-kicker">Unsubscribe</p>
          <h2 className="rep-title">We couldn’t complete your request</h2>
          <p className="rep-copy">
            This unsubscribe link may be invalid or expired. Please contact your
            clinic if you still want to stop receiving messages.
          </p>
        </section>
      </div>
    );
  }

  return (
    <div className="rep-shell unsubscribe-shell">
      <section className="rep-panel unsubscribe-panel">
        <div className="unsubscribe-icon unsubscribe-icon--success" aria-hidden="true">
          <i className="bi bi-check-circle" />
        </div>
        <p className="rep-kicker">Unsubscribe</p>
        <h2 className="rep-title">You have been unsubscribed</h2>
        <p className="rep-copy">
          You will no longer receive messages from us. If this was a mistake,
          please contact your clinic to update your communication preferences.
        </p>
      </section>
    </div>
  );
};

export default UnsubscribePage;
